export class GameLoop {
  private running = false;
  private last = 0;
  private frame = 0;
  private readonly tick: (dt: number, now: number) => void;

  constructor(tick: (dt: number, now: number) => void) {
    this.tick = tick;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    this.frame = requestAnimationFrame(this.onFrame);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.frame);
  }

  private onFrame = (now: number): void => {
    if (!this.running) return;
    const raw = (now - this.last) / 1000;
    this.last = now;
    const dt = Math.min(0.05, Math.max(0, raw));
    this.tick(dt, now);
    this.frame = requestAnimationFrame(this.onFrame);
  };
}
